module.exports = __webpack_public_path__ + "img/gateways_admin.0fce7e19.svg";